export const county_data = {
  counties: [
    { "state": "Alabama", "county": "Jefferson County", "population": 660000 },
    { "state": "Alabama", "county": "Mobile County", "population": 420000 },
    { "state": "Alabama", "county": "Madison County", "population": 370000 },
    { "state": "Alabama", "county": "Tuscaloosa County", "population": 220000 },
    { "state": "Alaska", "county": "Anchorage Municipality", "population": 290000 },
    { "state": "Alaska", "county": "Matanuska-Susitna Borough", "population": 110000 },
    { "state": "Alaska", "county": "Fairbanks North Star Borough", "population": 100000 },
    { "state": "Alaska", "county": "Kenai Peninsula Borough", "population": 57000 },
    { "state": "Arizona", "county": "Maricopa County", "population": 4480000 },
    { "state": "Arizona", "county": "Pima County", "population": 1000000 },
    { "state": "Arizona", "county": "Yavapai County", "population": 235000 },
    { "state": "Arizona", "county": "Yuma County", "population": 213000 },
    { "state": "Arkansas", "county": "Pulaski County", "population": 392000 },
    { "state": "Arkansas", "county": "Benton County", "population": 280000 },
    { "state": "Arkansas", "county": "Washington County", "population": 245000 },
    { "state": "Arkansas", "county": "Sebastian County", "population": 125000 },
    { "state": "California", "county": "Los Angeles County", "population": 10000000 },
    { "state": "California", "county": "San Diego County", "population": 3300000 },
    { "state": "California", "county": "Orange County", "population": 3200000 },
    { "state": "California", "county": "San Francisco County", "population": 880000 },
    { "state": "Colorado", "county": "Denver County", "population": 715000 },
    { "state": "Colorado", "county": "El Paso County", "population": 720000 },
    { "state": "Colorado", "county": "Arapahoe County", "population": 650000 },
    { "state": "Colorado", "county": "Adams County", "population": 525000 },
    { "state": "Connecticut", "county": "Fairfield County", "population": 950000 },
    { "state": "Connecticut", "county": "Hartford County", "population": 900000 },
    { "state": "Connecticut", "county": "New Haven County", "population": 850000 },
    { "state": "Connecticut", "county": "Litchfield County", "population": 180000 },
    { "state": "Delaware", "county": "New Castle County", "population": 560000 },
    { "state": "Delaware", "county": "Sussex County", "population": 240000 },
    { "state": "Delaware", "county": "Kent County", "population": 180000 },
    { "state": "Delaware", "county": "Other Delaware", "population": 0 },
    { "state": "Florida", "county": "Miami-Dade County", "population": 2716940 },
    { "state": "Florida", "county": "Broward County", "population": 1952778 },
    { "state": "Florida", "county": "Palm Beach County", "population": 1496770 },
    { "state": "Florida", "county": "Hillsborough County", "population": 1470000 },
    { "state": "Georgia", "county": "Fulton County", "population": 1050000 },
    { "state": "Georgia", "county": "Gwinnett County", "population": 936250 },
    { "state": "Georgia", "county": "Cobb County", "population": 760141 },
    { "state": "Georgia", "county": "DeKalb County", "population": 760000 },
    { "state": "Hawaii", "county": "Honolulu County", "population": 980000 },
    { "state": "Hawaii", "county": "Maui County", "population": 167000 },
    { "state": "Hawaii", "county": "Hawaii County", "population": 200000 },
    { "state": "Hawaii", "county": "Kauai County", "population": 73000 },
    { "state": "Idaho", "county": "Ada County", "population": 481587 },
    { "state": "Idaho", "county": "Canyon County", "population": 231105 },
    { "state": "Idaho", "county": "Kootenai County", "population": 160000 },
    { "state": "Idaho", "county": "Bannock County", "population": 87000 },
    { "state": "Illinois", "county": "Cook County", "population": 5200000 },
    { "state": "Illinois", "county": "DuPage County", "population": 930000 },
    { "state": "Illinois", "county": "Lake County", "population": 700000 },
    { "state": "Illinois", "county": "Will County", "population": 690000 },
    { "state": "Indiana", "county": "Marion County", "population": 960000 },
    { "state": "Indiana", "county": "Lake County", "population": 485000 },
    { "state": "Indiana", "county": "Allen County", "population": 380000 },
    { "state": "Indiana", "county": "Hamilton County", "population": 340000 },
    { "state": "Iowa", "county": "Polk County", "population": 490000 },
    { "state": "Iowa", "county": "Linn County", "population": 225000 },
    { "state": "Iowa", "county": "Scott County", "population": 175000 },
    { "state": "Iowa", "county": "Johnson County", "population": 150000 },
    { "state": "Kansas", "county": "Johnson County", "population": 600000 },
    { "state": "Kansas", "county": "Sedgwick County", "population": 520000 },
    { "state": "Kansas", "county": "Shawnee County", "population": 178000 },
    { "state": "Kansas", "county": "Wyandotte County", "population": 165000 },
    { "state": "Kentucky", "county": "Jefferson County", "population": 770000 },
    { "state": "Kentucky", "county": "Fayette County", "population": 320000 },
    { "state": "Kentucky", "county": "Kenton County", "population": 166000 },
    { "state": "Kentucky", "county": "Bullitt County", "population": 80000 },
    { "state": "Louisiana", "county": "East Baton Rouge Parish", "population": 440000 },
    { "state": "Louisiana", "county": "Orleans Parish", "population": 390000 },
    { "state": "Louisiana", "county": "Jefferson Parish", "population": 440000 },
    { "state": "Louisiana", "county": "Lafayette Parish", "population": 245000 },
    { "state": "Maine", "county": "Cumberland County", "population": 293000 },
    { "state": "Maine", "county": "York County", "population": 207000 },
    { "state": "Maine", "county": "Penobscot County", "population": 153000 },
    { "state": "Maine", "county": "Kennebec County", "population": 123000 },
    { "state": "Maryland", "county": "Montgomery County", "population": 1050000 },
    { "state": "Maryland", "county": "Prince George's County", "population": 909000 },
    { "state": "Maryland", "county": "Baltimore County", "population": 830000 },
    { "state": "Maryland", "county": "Howard County", "population": 330000 },
    { "state": "Massachusetts", "county": "Middlesex County", "population": 1610000 },
    { "state": "Massachusetts", "county": "Worcester County", "population": 830000 },
    { "state": "Massachusetts", "county": "Suffolk County", "population": 800000 },
    { "state": "Massachusetts", "county": "Essex County", "population": 790000 },
    { "state": "Michigan", "county": "Wayne County", "population": 1740000 },
    { "state": "Michigan", "county": "Oakland County", "population": 1200000 },
    { "state": "Michigan", "county": "Macomb County", "population": 870000 },
    { "state": "Michigan", "county": "Washtenaw County", "population": 370000 },
    { "state": "Minnesota", "county": "Hennepin County", "population": 1260000 },
    { "state": "Minnesota", "county": "Ramsey County", "population": 550000 },
    { "state": "Minnesota", "county": "Dakota County", "population": 430000 },
    { "state": "Minnesota", "county": "Anoka County", "population": 350000 },
    { "state": "Mississippi", "county": "Hinds County", "population": 230000 },
    { "state": "Mississippi", "county": "Harrison County", "population": 210000 },
    { "state": "Mississippi", "county": "DeSoto County", "population": 175000 },
    { "state": "Mississippi", "county": "Jackson County", "population": 150000 },
    { "state": "Missouri", "county": "St. Louis County", "population": 1000000 },
    { "state": "Missouri", "county": "Jackson County", "population": 700000 },
    { "state": "Missouri", "county": "St. Charles County", "population": 400000 },
    { "state": "Missouri", "county": "Greene County", "population": 290000 },
    { "state": "Montana", "county": "Yellowstone County", "population": 165000 },
    { "state": "Montana", "county": "Missoula County", "population": 120000 },
    { "state": "Montana", "county": "Gallatin County", "population": 115000 },
    { "state": "Montana", "county": "Flathead County", "population": 100000 },
    { "state": "Nebraska", "county": "Douglas County", "population": 570000 },
    { "state": "Nebraska", "county": "Lancaster County", "population": 317000 },
    { "state": "Nebraska", "county": "Sarpy County", "population": 190000 },
    { "state": "Nebraska", "county": "Buffalo County", "population": 48000 },
    { "state": "Nevada", "county": "Clark County", "population": 2266715 },
    { "state": "Nevada", "county": "Washoe County", "population": 471000 },
    { "state": "Nevada", "county": "Carson City", "population": 56000 },
    { "state": "Nevada", "county": "Lyon County", "population": 54000 },
    { "state": "New Hampshire", "county": "Hillsborough County", "population": 415000 },
    { "state": "New Hampshire", "county": "Rockingham County", "population": 310000 },
    { "state": "New Hampshire", "county": "Merrimack County", "population": 150000 },
    { "state": "New Hampshire", "county": "Strafford County", "population": 130000 },
    { "state": "New Jersey", "county": "Bergen County", "population": 932000 },
    { "state": "New Jersey", "county": "Middlesex County", "population": 825000 },
    { "state": "New Jersey", "county": "Essex County", "population": 800000 },
    { "state": "New Jersey", "county": "Hudson County", "population": 670000 },
    { "state": "New Mexico", "county": "Bernalillo County", "population": 679000 },
    { "state": "New Mexico", "county": "Doña Ana County", "population": 215000 },
    { "state": "New Mexico", "county": "Santa Fe County", "population": 150000 },
    { "state": "New Mexico", "county": "Sandoval County", "population": 140000 },
    { "state": "New York", "county": "Kings County", "population": 2559903 },
    { "state": "New York", "county": "Queens County", "population": 2253858 },
    { "state": "New York", "county": "New York County", "population": 1628706 },
    { "state": "New York", "county": "Suffolk County", "population": 1500000 },
    { "state": "North Carolina", "county": "Mecklenburg County", "population": 1100000 },
    { "state": "North Carolina", "county": "Wake County", "population": 1100000 },
    { "state": "North Carolina", "county": "Guilford County", "population": 540000 },
    { "state": "North Carolina", "county": "Forsyth County", "population": 380000 },
    { "state": "North Dakota", "county": "Cass County", "population": 180000 },
    { "state": "North Dakota", "county": "Grand Forks County", "population": 75000 },
    { "state": "North Dakota", "county": "Burleigh County", "population": 97000 },
    { "state": "North Dakota", "county": "Ward County", "population": 53000 },
    { "state": "Ohio", "county": "Cuyahoga County", "population": 1260000 },
    { "state": "Ohio", "county": "Franklin County", "population": 1300000 },
    { "state": "Ohio", "county": "Hamilton County", "population": 820000 },
    { "state": "Ohio", "county": "Montgomery County", "population": 530000 },
    { "state": "Oklahoma", "county": "Oklahoma County", "population": 800000 },
    { "state": "Oklahoma", "county": "Tulsa County", "population": 650000 },
    { "state": "Oklahoma", "county": "Cleveland County", "population": 280000 },
    { "state": "Oklahoma", "county": "Canadian County", "population": 150000 },
    { "state": "Oregon", "county": "Multnomah County", "population": 812000 },
    { "state": "Oregon", "county": "Washington County", "population": 600000 },
    { "state": "Oregon", "county": "Clackamas County", "population": 420000 },
    { "state": "Oregon", "county": "Lane County", "population": 380000 },
    { "state": "Pennsylvania", "county": "Philadelphia County", "population": 1584000 },
    { "state": "Pennsylvania", "county": "Allegheny County", "population": 1222000 },
    { "state": "Pennsylvania", "county": "Montgomery County", "population": 830000 },
    { "state": "Pennsylvania", "county": "Bucks County", "population": 630000 },
    { "state": "Rhode Island", "county": "Providence County", "population": 630000 },
    { "state": "Rhode Island", "county": "Kent County", "population": 170000 },
    { "state": "Rhode Island", "county": "Washington County", "population": 130000 },
    { "state": "Rhode Island", "county": "Newport County", "population": 82000 },
    { "state": "South Carolina", "county": "Greenville County", "population": 525000 },
    { "state": "South Carolina", "county": "Richland County", "population": 420000 },
    { "state": "South Carolina", "county": "Charleston County", "population": 410000 },
    { "state": "South Carolina", "county": "Spartanburg County", "population": 300000 },
    { "state": "South Dakota", "county": "Minnehaha County", "population": 193000 },
    { "state": "South Dakota", "county": "Pennington County", "population": 105000 },
    { "state": "South Dakota", "county": "Lincoln County", "population": 59000 },
    { "state": "South Dakota", "county": "Brookings County", "population": 35000 },
    { "state": "Tennessee", "county": "Shelby County", "population": 930000 },
    { "state": "Tennessee", "county": "Davidson County", "population": 715000 },
    { "state": "Tennessee", "county": "Knox County", "population": 470000 },
    { "state": "Tennessee", "county": "Hamilton County", "population": 370000 },
    { "state": "Texas", "county": "Harris County", "population": 4713325 },
    { "state": "Texas", "county": "Dallas County", "population": 2635516 },
    { "state": "Texas", "county": "Tarrant County", "population": 2000000 },
    { "state": "Texas", "county": "Bexar County", "population": 2000000 },
    { "state": "Utah", "county": "Salt Lake County", "population": 1200000 },
    { "state": "Utah", "county": "Utah County", "population": 650000 },
    { "state": "Utah", "county": "Davis County", "population": 360000 },
    { "state": "Utah", "county": "Weber County", "population": 260000 },
    { "state": "Vermont", "county": "Chittenden County", "population": 163000 },
    { "state": "Vermont", "county": "Rutland County", "population": 60000 },
    { "state": "Vermont", "county": "Washington County", "population": 57000 },
    { "state": "Vermont", "county": "Windsor County", "population": 58000 },
    { "state": "Virginia", "county": "Fairfax County", "population": 1140000 },
    { "state": "Virginia", "county": "Prince William County", "population": 470000 },
    { "state": "Virginia", "county": "Loudoun County", "population": 420000 },
    { "state": "Virginia", "county": "Arlington County", "population": 240000 },
    { "state": "Washington", "county": "King County", "population": 2252782 },
    { "state": "Washington", "county": "Pierce County", "population": 904980 },
    { "state": "Washington", "county": "Snohomish County", "population": 822000 },
    { "state": "Washington", "county": "Spokane County", "population": 525000 },
    { "state": "West Virginia", "county": "Kanawha County", "population": 180000 },
    { "state": "West Virginia", "county": "Monongalia County", "population": 105000 },
    { "state": "West Virginia", "county": "Berkeley County", "population": 120000 },
    { "state": "West Virginia", "county": "Wood County", "population": 85000 },
    { "state": "Wisconsin", "county": "Milwaukee County", "population": 945000 },
    { "state": "Wisconsin", "county": "Dane County", "population": 550000 },
    { "state": "Wisconsin", "county": "Waukesha County", "population": 406000 },
    { "state": "Wisconsin", "county": "Brown County", "population": 264000 },
    { "state": "Wyoming", "county": "Laramie County", "population": 100000 },
    { "state": "Wyoming", "county": "Natrona County", "population": 79000 },
    { "state": "Wyoming", "county": "Campbell County", "population": 15000 },
    { "state": "Wyoming", "county": "Sweetwater County", "population": 45000 }
  ]
};